export default [
  { label: '$USD', value: 'USD' },
  { label: '£GBP', value: 'GBP' },
  { label: '€EUR', value: 'EUR' },
  { label: '$AUD', value: 'AUD' },
]
